import { state } from './state';

const mutations = {
  setIdentityList(val): void {
    state.identity.identityList.value = val;
  },
  setCurIdentity(val): void {
    state.identity.curIdentity.value = val;
  },
  setDisplayName(name) {
    state.identity.displayName.value = name;
  },
  setAvatarIcon(avatar) {
    state.identity.avatarIcon.value = avatar;
  },
  setLocalDisplayName(name) {
    state.identity.localDisplayName.value = name;
  },
  setLocalAvatarIcon(avatar) {
    state.identity.localAvatarIcon.value = avatar;
  },
  setNativeVideoHasMore(val): void {
    state.identity.nativeVideoHasMore.value = val;
  },
  setNativeVideoCursor(val): void {
    state.identity.nativeVideoCursor.value = val;
  },
  setNativeVideoIdentityId(val): void {
    state.identity.nativeVideoIdentityId.value = val;
  },
  setNativeVideoList(val): void {
    state.identity.nativeVideoList.value = val;
  },
  updateNativeVideoList(val): void {
    state.identity.nativeVideoList.value = state.identity.nativeVideoList.value.concat(val);
  },
  setUseTikTokIdentity(useTikTokIdentity) {
    state.identity.useTikTokIdentity.value = useTikTokIdentity;
  },
  setIdentityStatus(value) {
    state.identity.identityInit.value = value;
  }
};

export default mutations;
